/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceConnectionReportResultModelSearchResultModel } from '../../models/device-connection-report-result-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface ReportDeviceConnectionReportPost$Params {
  
    /**
     * Search request with paging, sort, and filter.
     */
    body?: SearchRequestModel
}

export function reportDeviceConnectionReportPost(http: HttpClient, rootUrl: string, params?: ReportDeviceConnectionReportPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<DeviceConnectionReportResultModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, reportDeviceConnectionReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<DeviceConnectionReportResultModelSearchResultModel>;
    })
  );
}

reportDeviceConnectionReportPost.PATH = '/Report/DeviceConnectionReport';
